import React, { useEffect, useState } from "react";
import "./Contact_us_Form.css";
import Breadcrumb_comp from "../../common-components/breadcrumb-comp/Breadcrumb_comp";
import { Col, Form, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useForm, Controller } from "react-hook-form";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import classNames from "classnames";
import Success_New from "../../Animation/Success_New/Success_New";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

// ✅ SOLID icons (UI icons)
import {
  faMapLocationDot,
  faEnvelope,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import Green_round_btn from "../../common-components/common_btn/green_round_btn/Green_round_btn";
import Success_Modal from "../../common-components/common_modal/success_modal/Success_Modal";
import { useDispatch, useSelector } from "react-redux";
import { contactusForm } from "../../../features/contact_us/contactusSlice";
import { appSetup, SocialLink } from "../../../features/master/masterSlice";
import MapView from "./map";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import {
  faWhatsapp,
  faWhatsappSquare,
} from "@fortawesome/free-brands-svg-icons";
import Common_Title from "../../common-components/common_title/Common_Title";
import Common_Btn_Yellow from "../../common-components/common_btn_yellow/Common_Btn_Yellow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

function Contact_us_Form() {
  const dispatch = useDispatch();

  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const handle = useFullScreenHandle();

  const {
    control,
    reset,
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const expandMap = () => {
    if (handle.active) {
      handle.exit();
    } else {
      handle.enter();
    }
  };
  const message = watch("message", "");

  const [isSubmitting, setIsSubmitting] = useState(false);

  const toggleMap = () => {
    if (!showMap) window.scrollTo({ top: 0, behavior: "smooth" });
    if (showMap && handle.active) {
      handle.exit();
    }
    setShowMap(!showMap);
  };

  const onSubmit = (data) => {
    dispatch(contactusForm(data));
    console.log("Form Submitted", data);
    setShowSucsessModal(true);
    reset();
  };

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "CONTACT US", link: "", isActive: true },
  ];

  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  const sociallink = useSelector((state) => state.master.social_link);

  useEffect(() => {
    dispatch(SocialLink());
  }, [dispatch]);

  const buildWhatsAppHref = (rawNumber, defaultCountryCode = "") => {
    if (!rawNumber) return null;

    let cleaned = String(rawNumber).replace(/\D/g, "");

    cleaned = cleaned.replace(/^0+/, "");

    if (cleaned.length === 10) {
      cleaned = `${defaultCountryCode}${cleaned}`;
    }

    if (!/^\d+$/.test(cleaned)) return null;
    if (cleaned.length < 11 || cleaned.length > 15) {
      return null;
    }

    const url = `https://wa.me/${cleaned}`;

    return url;
  };

  const phoneHref = buildWhatsAppHref(app_setup?.alt_contact_no);
  return (
    <section className="contact-section">
      {/* <Breadcrumb_comp breadcrumbs={breadcrumbs} /> */}

      <div className="container">
        <div className="contact-heading">
          <Common_Title titleStart="Send Us a Message" />
          <p className="have-q">
            Have questions about medicines, orders, or prescriptions?
          </p>
          <p className="have-q">
            Fill out the form below and our support team will get back to you as
            soon as possible.
          </p>
        </div>

        <div className="contact-card">
          {!showMap && (
            <div className="row">
              <div className="col-lg-6">
                <Form.Group className="mb-3"></Form.Group>

                <div className="form_holder">
                  <div className="leftdivv">
                    {!showSuccessModal ? (
                      <>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                          <Form.Group className="mb-3">
                            <Form.Label>Name</Form.Label>

                            <Form.Control
                              type="text"
                              placeholder="Enter your full name"
                              {...register("name", {
                                required: "Name is required",
                              })}
                              className={classNames({
                                "is-invalid": errors?.name,
                              })}
                              onKeyDown={(event) => {
                                if (
                                  !/[A-Za-z ]/.test(event.key) &&
                                  ![
                                    "Backspace",
                                    "Tab",
                                    "ArrowLeft",
                                    "ArrowRight",
                                  ].includes(event.key)
                                ) {
                                  event.preventDefault();
                                }
                              }}
                            />

                            {errors?.name && (
                              <div className="invalid-feedback">
                                {errors.name.message}
                              </div>
                            )}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>

                            <Form.Control
                              type="email"
                              placeholder="Enter your mail id"
                              {...register("email", {
                                required: "Email Id required",
                                pattern: {
                                  value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                                  message: "Email Id Invalid",
                                },
                              })}
                              className={classNames({
                                "is-invalid": errors?.email,
                              })}
                            />

                            {errors?.email && (
                              <div className="invalid-feedback">
                                {errors.email.message}
                              </div>
                            )}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>Contact Number</Form.Label>

                            <Controller
                              name="number"
                              control={control}
                              defaultValue=""
                              rules={{
                                required: "Mobile number is required",
                                pattern: {
                                  value: /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{4})[-. )]*(\d{4})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
                                  message: "Number must be 10 digit",
                                },
                              }}
                              render={({ field: { onChange, value } }) => (
                                <PhoneInput
                                  className="phone-no"
                                  country={""}
                                  value={value}
                                  onChange={onChange}
                                  placeholder="" // IMPORTANT: keep empty
                                  inputProps={{
                                    name: "number",
                                    required: true,
                                    placeholder: "Enter your number", // 👈 force here
                                  }}
                                  inputClass="form-control"
                                />
                              )}
                            />

                            {errors?.number && (
                              <div className="invalid-feedback d-block">
                                {errors.number.message}
                              </div>
                            )}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>Message</Form.Label>

                            <Form.Control
                              as="textarea"
                              rows={4}
                              maxLength={1000}
                              placeholder="Enter your message"
                              {...register("message", {
                                required: "Message required",
                                minLength: {
                                  value: 10,
                                  message:
                                    "Message must be at least 10 characters",
                                },
                                maxLength: {
                                  value: 1000,
                                  message:
                                    "Message must not exceed 1000 characters",
                                },
                              })}
                              className={classNames({
                                "is-invalid": errors?.message,
                              })}
                            />
                            <small className="text-muted">
                              {message.length}/1000
                            </small>
                            {errors?.message && (
                              <div className="invalid-feedback">
                                {errors.message.message}
                              </div>
                            )}
                          </Form.Group>

                          <Common_Btn_Yellow
                            type="submit"
                            disabled={isSubmitting}
                            text={isSubmitting ? "Sending..." : "Submit Now"}
                          />
                        </Form>
                      </>
                    ) : (
                      <>
                        <Success_Modal
                          show={showSuccessModal}
                          onHide={() => setShowSucsessModal(false)}
                          successText="Message Sent Successfully!"
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="contact-info">
                  <h5>Get in touch</h5>

                  {/* Address */}
                  <div className="info-box">
                    <strong>
                      <span className="icon-box">
                        <FontAwesomeIcon icon={faMapLocationDot} />
                      </span>
                      Address
                    </strong>

                    <p
                      className="cursor-pointer"
                      // onClick={toggleMap}
                    >
                      {app_setup?.address || ""}
                    </p>
                  </div>

                  {/* Email */}
                  <div className="info-box">
                    <strong>
                      <span className="icon-box">
                        <FontAwesomeIcon icon={faEnvelope} />
                      </span>
                      Email
                    </strong>

                    <p>
                      <a
                        href={`mailto:${app_setup?.email}`}
                        className="text-decoration-none"
                      >
                        {app_setup?.email || ""}
                      </a>
                    </p>
                  </div>

                  {/* Phone */}
                  <div className="info-box">
                    <strong>
                      <span className="icon-box">
                        <FontAwesomeIcon icon={faPhone} />
                      </span>
                      Phone Number
                    </strong>

                    <p>
                      <a
                        href={`tel:${app_setup?.contact_no}`}
                        className="text-decoration-none"
                      >
                        {app_setup?.contact_no || ""}
                      </a>
                    </p>
                  </div>

                  {/* WhatsApp */}
                  {/* <div className="info-box">
                    <strong>
                      <span className="icon-box">
                        <FontAwesomeIcon icon={faWhatsappSquare} />
                      </span>
                      WhatsApp
                    </strong>

                    {phoneHref ? (
                      <p>
                        <a
                          href={phoneHref}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                        >
                          {app_setup?.alt_contact_no}
                        </a>
                      </p>
                    ) : (
                      <p className="text-danger">Invalid phone number</p>
                    )}
                  </div> */}

                  {/* Social Icons */}
                  <div className="social-icons">
                    {sociallink?.map((val) => (
                      <Link to={val?.url} className="social-icon">
                        <img
                          src={process.env.REACT_APP_IMG_URL + val?.image}
                          className="social_icon_img"
                          alt="Get it on Google Play"
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* <FullScreen handle={handle}>
                        <div
                            className={`map ${!showMap ? "hidden" : "show"} ${handle.active ? "fullscreen" : ""
                                }`}
                        >
                            <iframe
                                className="gmap_iframe"
                                frameBorder="0"
                                scrolling="no"
                                marginHeight="0"
                                marginWidth="0"
    
                                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15133.39075304903!2d73.7810866!3d18.5131838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1719574302642!5m2!1sen!2sin"
                                title="Google Map"
                            ></iframe>
                            <div className="close">
                                <div className="map-icons">
                                    <FontAwesomeIcon
                                        icon={handle.active ? faMinimize : faMaximize}
                                        className="map_icon expand"
                                        onClick={expandMap}
                                    />
                                    <FontAwesomeIcon
                                        icon={faCircleXmark}
                                        className="map_icon close-icon"
                                        onClick={toggleMap}
                                    />
                                </div>
                            </div>
                        </div>
                    </FullScreen> */}
        </div>

        {/* <MapView
        lat={appSetup?.lat}
        lng={appSetup?.long}
        showMap={showMap}
        handle={handle}
        expandMap={expandMap}
        toggleMap={toggleMap}
      /> */}
      </div>

      <div className="map-section">
        <iframe
          title="map"
          // src="https://maps.google.com/maps?output=embed"
          src={`https://maps.google.com/maps?q=${Number(
            app_setup?.lat,
          )},${Number(app_setup?.long)}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
          width="100%"
          height="400"
          style={{ border: 0 }}
          loading="lazy"
        ></iframe>
      </div>
    </section>
  );
}

export default Contact_us_Form;
